var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "AuthorForm" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "title" }, [
        _c("a", { staticClass: "back", attrs: { href: "/" } }, [
          _vm._v(_vm._s(_vm.$t("BUTTON.BACK")))
        ]),
        _c("h2", [_vm._v(_vm._s(_vm.$t("AUTHORFORM.TITLE")))])
      ]),
      !_vm.loading
        ? _c(
            "form",
            {
              on: {
                input: function($event) {
                  return _vm.validation($event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "form-block" },
                [
                  _vm._l(_vm.fields, function(field, i) {
                    return _c(
                      "BaseInput",
                      _vm._b(
                        {
                          key: i,
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "error",
                                fn: function() {
                                  return [
                                    _c("ValidationError", {
                                      attrs: {
                                        errors: _vm.errors,
                                        name: field.name
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: field.value,
                            callback: function($$v) {
                              _vm.$set(field, "value", $$v)
                            },
                            expression: "field.value"
                          }
                        },
                        "BaseInput",
                        field,
                        false
                      )
                    )
                  }),
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.genre,
                      label: _vm.$t("AUTHORFORM.GENRE"),
                      tag: "genero_id",
                      options: _vm.getGen
                    },
                    model: {
                      value: _vm.genre,
                      callback: function($$v) {
                        _vm.genre = $$v
                      },
                      expression: "genre"
                    }
                  }),
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.province,
                      label: _vm.$t("AUTHORFORM.TERRITORY"),
                      tag: "territorio_id",
                      options: _vm.terName
                    },
                    model: {
                      value: _vm.province,
                      callback: function($$v) {
                        _vm.province = $$v
                      },
                      expression: "province"
                    }
                  }),
                  _c("div", { staticClass: "fileInput" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("AUTHORFORM.PICTURE")))]),
                    _c("input", {
                      attrs: { type: "file", name: "usr_image_id" },
                      on: { change: _vm.loadImage }
                    })
                  ]),
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.anotherActivity,
                      label: _vm.$t("AUTHORFORM.ACTIVITY"),
                      tag: "otraactividad_id",
                      options: _vm.getAct
                    },
                    model: {
                      value: _vm.anotherActivity,
                      callback: function($$v) {
                        _vm.anotherActivity = $$v
                      },
                      expression: "anotherActivity"
                    }
                  })
                ],
                2
              ),
              _c("div", { staticClass: "declaration-box" }, [
                _c("p", {
                  staticClass: "declaration",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("AUTHORFORM.DECLARATION", {
                        path: _vm.documentPath
                      })
                    )
                  }
                }),
                _c("div", { staticClass: "fileInput" }, [
                  _c("span", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("AUTHORFORM.DECLARATION4")) + " "
                    )
                  ]),
                  _c("input", {
                    attrs: { type: "file", name: "dec_id" },
                    on: { change: _vm.loadImage }
                  })
                ])
              ]),
              _c("div", { staticClass: "message" }, [
                _vm.created
                  ? _c("p", { staticClass: "created" }, [
                      _vm._v(" Usuario registrado correctamente ")
                    ])
                  : _vm._e()
              ]),
              _c(
                "div",
                { staticClass: "button-sub" },
                [
                  _c("BaseButton", { on: { click: _vm.submitData } }, [
                    _vm._v(" " + _vm._s(_vm.$t("BUTTON.SAVE")) + " ")
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }